var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInstagram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Instagram 1",
    clipPath: "url(#clip0_1_145)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Symbol"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M13.8092 0.770361C14.3471 0.979541 14.802 1.25845 15.2569 1.71333C15.7118 2.16489 15.9907 2.6231 16.1999 3.15767C16.4024 3.67563 16.5385 4.26997 16.5784 5.13989C16.6182 6.00981 16.6282 6.28872 16.6282 8.50669C16.6282 10.7247 16.6182 11.0036 16.5784 11.8735C16.5385 12.7434 16.3991 13.3377 16.1999 13.8557C15.9907 14.3936 15.7118 14.8485 15.2569 15.3034C14.802 15.7583 14.3471 16.0372 13.8092 16.2463C13.2913 16.4489 12.6969 16.585 11.827 16.6249C10.9571 16.6647 10.6782 16.6747 8.4602 16.6747C6.24224 16.6747 5.96333 16.6647 5.09341 16.6249C4.22349 16.585 3.62915 16.4456 3.11118 16.2463C2.57329 16.0372 2.11841 15.7583 1.66353 15.3034C1.20864 14.8485 0.929737 14.3936 0.720557 13.8557C0.518019 13.3377 0.381886 12.7434 0.342041 11.8735C0.302197 11.0036 0.292236 10.7247 0.292236 8.50669C0.292236 6.28872 0.302197 6.00981 0.342041 5.13989C0.381886 4.26997 0.521339 3.67563 0.720557 3.15767C0.929737 2.6231 1.20864 2.16489 1.66021 1.71333C2.11509 1.25845 2.56997 0.979541 3.10786 0.770361C3.62583 0.567822 4.22017 0.431689 5.09009 0.391846C5.96001 0.352002 6.23892 0.342041 8.45689 0.342041C10.6749 0.342041 10.9538 0.352002 11.8237 0.391846C12.6969 0.428369 13.2913 0.567822 13.8092 0.770361ZM5.15981 1.85942C4.36294 1.89595 3.9313 2.02876 3.64243 2.14165C3.2606 2.29106 2.98833 2.46704 2.70278 2.75259C2.41724 3.03813 2.24126 3.3104 2.09185 3.69224C1.97896 3.9811 1.84614 4.41274 1.80962 5.20962C1.76978 6.06958 1.76313 6.32856 1.76313 8.51001C1.76313 10.6915 1.7731 10.9504 1.80962 11.8104C1.84614 12.6073 1.97896 13.0389 2.09185 13.3278C2.24126 13.7096 2.41724 13.9819 2.70278 14.2674C2.98833 14.553 3.2606 14.729 3.64243 14.8784C3.9313 14.9913 4.36294 15.1241 5.15981 15.1606C6.01978 15.2004 6.27876 15.2071 8.4602 15.2071C10.6416 15.2071 10.9006 15.1971 11.7606 15.1606C12.5575 15.1241 12.9891 14.9913 13.278 14.8784C13.6598 14.729 13.9321 14.553 14.2176 14.2674C14.5032 13.9819 14.6792 13.7096 14.8286 13.3278C14.9415 13.0389 15.0743 12.6073 15.1108 11.8104C15.1506 10.9504 15.1573 10.6915 15.1573 8.51001C15.1573 6.32856 15.1473 6.06958 15.1108 5.20962C15.0743 4.41274 14.9415 3.9811 14.8286 3.69224C14.6792 3.3104 14.5032 3.03813 14.2176 2.75259C13.9321 2.46704 13.6598 2.29106 13.278 2.14165C12.9891 2.02876 12.5575 1.89595 11.7606 1.85942C10.9006 1.81958 10.6416 1.81294 8.4602 1.81294C6.27876 1.81294 6.01978 1.81958 5.15981 1.85942Z",
    fill: "url(#paint0_radial_1_145)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M12.6538 8.50996C12.6538 10.8275 10.7745 12.7035 8.46025 12.7035C6.146 12.7035 4.2667 10.8242 4.2667 8.50996C4.2667 6.1957 6.14267 4.31641 8.46025 4.31641C10.7778 4.31641 12.6538 6.19238 12.6538 8.50996ZM5.7376 8.50996C5.7376 10.0141 6.95615 11.2326 8.46025 11.2326C9.96435 11.2326 11.1829 10.0141 11.1829 8.50996C11.1829 7.00586 9.96435 5.7873 8.46025 5.7873C6.95615 5.7873 5.7376 7.00586 5.7376 8.50996Z",
    fill: "url(#paint1_radial_1_145)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M4.09729 5.12988C3.55633 5.12988 3.1178 4.69135 3.1178 4.15039C3.1178 3.60943 3.55633 3.1709 4.09729 3.1709C4.63825 3.1709 5.07678 3.60943 5.07678 4.15039C5.07678 4.69135 4.63825 5.12988 4.09729 5.12988Z",
    fill: "#654C9F"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_1_145",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(16.3309 15.1793) rotate(-177) scale(23.6178 20.0749)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FED576"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2634,
    stopColor: "#F47133"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6091,
    stopColor: "#BC3081"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4C63D2"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_1_145",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(12.5017 11.9344) rotate(-177) scale(12.1281 10.3088)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FED576"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2634,
    stopColor: "#F47133"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6091,
    stopColor: "#BC3081"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4C63D2"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_145"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 17,
    height: 17,
    fill: "white",
    transform: "matrix(-1 0 0 1 17 0)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagram);
export default __webpack_public_path__ + "static/media/Instagram.60138354253a43399e0c6c9b14605594.svg";
export { ForwardRef as ReactComponent };